<template>
  <v-card v-if="completedInspections" outlined max-width="400" class="mb-5">
    <v-card-title class="py-2 px-3">
      <span class="subtitle-2">過去の検収結果</span>
      <v-spacer />
      <v-btn v-if="show" icon @click="show = false">
        <v-icon> mdi-menu-up </v-icon>
      </v-btn>
      <v-btn v-else icon @click="show = true">
        <v-icon> mdi-menu-down </v-icon>
      </v-btn>
    </v-card-title>
    <template v-if="show">
      <v-divider />
      <v-card-text>
        <div
          v-for="(inspection, index) in completedInspections"
          :key="index"
          class="pb-3"
        >
          <v-divider v-if="index != 0" />
          <div class="caption my-3">
            検収完了日時：{{ inspection.completedAt | moment }}
          </div>
          <div
            v-if="inspection.feedback"
            class="pa-1"
            style="background-color: "
          >
            <markdown-preview :source="inspection.feedback" />
          </div>
        </div>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import MarkdownPreview from '@/components/commons/MarkdownPreview'

export default {
  components: {
    MarkdownPreview
  },
  filters: {
    moment: function (date) {
      if (date == null) {
        return ''
      }
      return moment(date).format('YYYY年M月D日 HH時mm分')
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters({ completedInspections: 'PostEditor/completedInspections' })
  }
}
</script>

<style scoped></style>
